package com.ijoin.data.api

import com.ijoin.data.api.ApiClient.addAuthToken
import com.ijoin.data.model.ConnectAccountStatus
import com.ijoin.data.model.ConnectDashboardLinkResponse
import com.ijoin.data.model.ConnectOnboardingLinkResponse
import com.ijoin.data.model.OnboardingRequest
import com.ijoin.data.model.SwitchPayoutModeRequest
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class ConnectApi {
    private val client = ApiClient.client
    private val baseUrl = "${ApiClient.getBaseUrl()}/api/connect"

    suspend fun getConnectStatus(): Result<ConnectAccountStatus> {
        return safeApiCall {
            client.get("$baseUrl/status") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun createOnboardingLink(
        refreshUrl: String,
        returnUrl: String
    ): Result<ConnectOnboardingLinkResponse> {
        return safeApiCall {
            client.post("$baseUrl/onboarding") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(OnboardingRequest(refreshUrl, returnUrl))
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun getDashboardLink(): Result<ConnectDashboardLinkResponse> {
        return safeApiCall {
            client.post("$baseUrl/dashboard-link") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun switchPayoutMode(targetMode: String): Result<ConnectAccountStatus> {
        return safeApiCall {
            client.post("$baseUrl/switch-mode") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(SwitchPayoutModeRequest(targetMode))
            }
        }.mapCatching { response -> response.body() }
    }

    suspend fun disconnect(): Result<ConnectAccountStatus> {
        return safeApiCall {
            client.post("$baseUrl/disconnect") {
                addAuthToken()
            }
        }.mapCatching { response -> response.body() }
    }
}
